import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from 'react';
import { useQuery } from 'react-query';
import * as API from '../../API';
import './ApiText.scss';
export const ApiText = ({ className, knr, topic, sector, keyfigure, index }) => {
    var _a, _b, _c, _d;
    const paragraphs = useRef([]);
    const { data: apiTextData } = useQuery(`kb/kommuner/${knr}/analysetekster`, () => API.fetchApiText(knr));
    if (apiTextData && sector && keyfigure) { // Texts for keyfigures within sectors within Municipalities
        const textData = apiTextData;
        paragraphs.current = ((_a = textData[topic][sector][keyfigure]) !== null && _a !== void 0 ? _a : []).map((paragraph, index) => {
            const clsx = [className, `api-text keyfigure-scope topic-${topic} sector-${sector}  keyfigure-${keyfigure}`, `paragraph_${index + 1}`].join(' ');
            return (_jsx("p", { dangerouslySetInnerHTML: { __html: paragraph }, className: clsx }, `${topic}_${sector}_${keyfigure}_${index}`));
        });
    }
    else if (apiTextData && sector) { // Texts for sectors within Municipalities
        const textData = apiTextData;
        paragraphs.current = ((_b = textData[topic][sector]) !== null && _b !== void 0 ? _b : []).map((paragraph, index) => {
            const clsx = [className, `api-text sector-scope sector-${sector} topic-${topic}`, `paragraph_${index + 1}`].join(' ');
            return (_jsx("p", { dangerouslySetInnerHTML: { __html: paragraph }, className: clsx }, `${topic}_${sector}_${index}`));
        });
    }
    else if (apiTextData) { // Texts for Municipalities
        const textData = apiTextData;
        paragraphs.current = ((_c = textData[topic]) !== null && _c !== void 0 ? _c : []).map((paragraph, index) => {
            const clsx = [className, `api-text municipality-scope topic-${topic}`, `paragraph_${index + 1}`].join(' ');
            return (_jsx("p", { dangerouslySetInnerHTML: { __html: paragraph }, className: clsx }, `${topic}_${index}`));
        });
    }
    return (index === undefined ? _jsx(_Fragment, { children: paragraphs.current })
        : ((_d = paragraphs.current[index]) !== null && _d !== void 0 ? _d : null));
};
